import React from 'react';

import { ContactForm } from '../../../contact/components';
import { useContactForm } from '../../../contact/useContactForm';

/**
 * Contact settings section — the support contact form, now a Settings subpage
 * (it was a standalone top-level page reached from the side menu). Self-contained
 * like {@link CasinoSettingsSection}: it owns its form state via {@link useContactForm}
 * so that logic only runs while the Contact section is active. Rendered inside the
 * section's content-capped `Contents` under the shared BackHeader, exactly like the
 * other Settings sections.
 */
export const ContactSection = (): React.ReactElement => {
  const form = useContactForm();

  return (
    <ContactForm
      values={form.values}
      errors={form.errors}
      dirty={form.dirty}
      sending={form.sending}
      sendError={form.sendError}
      justSent={form.justSent}
      onChange={form.onChange}
      onSubmit={form.submit}
    />
  );
};

export default ContactSection;
